import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import Experiencia from "@/components/sections/Experiencia";
import AreasDeAtuacao from "@/components/sections/AreasDeAtuacao";
import AdvocaciaEstrategica from "@/components/sections/AdvocaciaEstrategica";
import Diferenciais from "@/components/sections/Diferenciais";
import ParaQuemAtuamos from "@/components/sections/ParaQuemAtuamos";
import CTAAgendar from "@/components/sections/CTAAgendar";
import FAQ from "@/components/sections/FAQ";
import Contato from "@/components/sections/Contato";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white text-brand-text" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Experiencia />
        <AreasDeAtuacao />
        <AdvocaciaEstrategica />
        <Diferenciais />
        <ParaQuemAtuamos />
        <CTAAgendar />
        <FAQ />
        <Contato />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
